export default __webpack_public_path__ + "static/media/map.9a07903d.gif";